// extracted by mini-css-extract-plugin
module.exports = {"pcWrap":"pcWrap___2aJUj","mobileWrap":"mobileWrap___2awY5","pcArrow":"pcArrow___3zReP","mobileArrow":"mobileArrow___7v699"};